import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

interface JobCleanupDialogProps {
  open: boolean;
  cleanupLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function JobCleanupDialog({open, cleanupLoading, onCancel, onConfirm}: JobCleanupDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Cleanup Old Jobs</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will permanently delete all old jobs. This action cannot be undone. Are you sure you want to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={cleanupLoading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="warning" disabled={cleanupLoading}>
          {cleanupLoading ? 'Cleaning...' : 'Cleanup'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
